// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"6c97069c","770":"3219385e","864":"db29c247"}[chunkId] + ".chunk.js";
};